export default {
  es: {
    hello: 'Hola, iniciemos su registro',
    continue: 'Continuar',
    welcome:
      'Le damos la bienvenida al sistema del programa de Nefroplus RCS de Vantive. Para continuar, ingrese su número de documento de identidad.',
    confirmPass: 'Confirmar contraseña',
    createTitle: 'Cree una contraseña',
    createContent:
      'Ahora debe asignar una contraseña, la cual se le solicitará para el inicio de sesión. Esta debe contener mínimo 8 caracteres y al menos una letra mayuscula, una letra minuscula, un caracter especial y un número.',
    lastStep: 'Un último paso',
    lastStepContent:
      'Por favor lea atentamente los Términos y condiciones del servicio contenidos en el siguiente enlace.',
    lastStepContent2:
      'Por favor lea atentamente las Políticas de privacidad del servicio contenidas en el siguiente enlace.',
    terms: 'Términos y condiciones',
    privacy: 'Políticas de privacidad',
    registerMe: 'Registrarme',
    acceptTerms:
      'Confirmo que he leído y acepto los Términos y Condiciones del servicio',
    acceptPrivacy:
      'Confirmo que he leído y acepto las Políticas de privacidad y tratamieto de datos del servicio',
    termsContent:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Penatibus in nullam lectus phasellus sit mollis faucibus. Eget mauris cursus accumsan scelerisque cursus erat faucibus ultricies. Arcu facilisis suspendisse consectetur dolor aliquet. Vel et enim euismod aenean aliquam, nunc. Lacus vulputate massa, pellentesque neque, ante. Eu morbi egestas egestas parturient pharetra. At congue vitae urna, ac nisi, aenean pellentesque neque. Sed potenti at suspendisse amet egestas. Diam elementum, posuere lorem velit ut rhoncus ac a. Ullamcorper in quis magnis quisque ullamcorper porttitor. Integer orci, morbi ut volutpat lectus varius neque in. Ut purus orci dictum non. Viverra vestibulum.',
    notification: 'Notificación',
    succesPass: '¡Contraseña asignada con éxito!',
    startSesion: 'Iniciar Sesión',
    activeUser: '¡Ya eres un usuario activo!',
    succesRegister:
      '¡Se ha registrado con éxito. Puede iniciar sesión con sus credenciales!',
    newPass:
      'Escriba una nueva contraseña y confírmela. Esta debe contener mínimo 8 caracteres incluyendo al menos un número.',
    changePass: 'Cambiar contraseña',
    somethingWasWrong: 'Algo salió mal',
    resetPassword: 'Recuperar contraseña',
    changePassError:
      'Se ha presentado un error, por favor solicite de nuevo la recuperación de su contraseña.',
    updateData: 'Actualizar datos',
    newPassword: 'Nueva contraseña',
    currentPassword: 'Contraseña actual'
  },
  en: {
    login: `Hello, let's start your registration`,
    continue: 'Continue',
    welcome:
      'Welcome to the Vantive Nefroplus RCS program system. To continue, type your ID number.',
    confirmPass: 'Confirm password',
    createTitle: 'Create a password',
    createContent:
      'You must now assign a password, which will be requested for login. This must contain a minimum of 8 characters and at least one uppercase letter, one lowercase letter, one special character and one number.',
    lastStep: 'One last step',
    lastStepContent:
      'Please read carefully the Terms and conditions of the service contained in the following link.',
    lastStepContent2:
      'Please read carefully the Privacy policies of the service contained in the following link.',
    terms: 'Terms and conditions',
    privacy: 'Privacy policies',
    registerMe: 'Register me',
    acceptTerms:
      'I confirm that I have read and accept the Terms and Conditions of the service',
    acceptPrivacy:
      'I confirm that I have read and accept the privacy and data processing policies of the service',
    termsContent:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Penatibus in nullam lectus phasellus sit mollis faucibus. Eget mauris cursus accumsan scelerisque cursus erat faucibus ultricies. Arcu facilisis suspendisse consectetur dolor aliquet. Vel et enim euismod aenean aliquam, nunc. Lacus vulputate massa, pellentesque neque, ante. Eu morbi egestas egestas parturient pharetra. At congue vitae urna, ac nisi, aenean pellentesque neque. Sed potenti at suspendisse amet egestas. Diam elementum, posuere lorem velit ut rhoncus ac a. Ullamcorper in quis magnis quisque ullamcorper porttitor. Integer orci, morbi ut volutpat lectus varius neque in. Ut purus orci dictum non. Viverra vestibulum.',
    notification: 'Notification',
    succesPass: '¡Password successfully assigned!',
    startSesion: 'Login',
    activeUser: '¡You are already an active user!',
    succesRegister:
      '¡You have registered successfully. You can log in with your credentials!',
    newPass:
      'Type a new password and confirm. This must contain a minimum of 8 characters including at least one number.',
    somethingWasWrong: 'Something was wrong',
    resetPassword: 'Reset your password',
    changePassError:
      'An error has ocurred, please request for your password recovery again',
    changePass: 'Change password',
    updateData: 'Update data',
    newPassword: 'New password',
    currentPassword: 'Current password'
  }
};
